/* eslint-disable max-len */
/**
 * Finnish translations.
 */
export default {
  ACTION: {
    LINK_COPY: 'Kopioi'
  },
  ERROR: {},
  HEADER: {
    NAME: 'Nimi',
    PROFIT_MARGIN: 'Voittomarginaali'
  },
  LABEL: {
    GENERATE_LINK: 'Luo linkki',
    GENERATED_LINK: 'Generoitu linkki',
    NAME: 'Nimi',
    PROFIT_MARGIN: 'Voittomarginaali'
  },
  SENTENCE: {},
  SUCCESS: {
    LINK_COPIED: 'Linkki kopioitu'
  },
  TOOLTIP: {
    NAME: 'Nimi',
    PROFIT_MARGIN: 'Voittomarginaali'
  }
};
